import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Close from "../../assets/images/close-icon.png";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import "../../components/common/css/datatable.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import axios from "axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import Select from "react-select";

const Report = () => {
  const [id, setID] = useState();

  const [employees, setEmployees] = useState([]);
  const [employeeID, setEmployeeID] = useState();
  const [getEmployee, setEmployee] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const ref = React.createRef();
  const [reportUrl, setReportUrl] = useState("");
  const [pdfDownload, setPdfDownload] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [CuctomerEmail, setEmail] = useState(false);
  const [CampaignName, setCampaignName] = useState(false);
  const [AmountInvested, setAmount] = useState(false);
  const [COMMISSION, setCommission] = useState(false);

  const [CustomerCountry, setCountry] = useState(false);
  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.coupon_owner);
    setEmail(row?.CuctomerEmail);
    setCampaignName(row?.CampaignName);
    setAmount(row?.AmountInvested);
    setCommission(row?.COMMISSION);
    setCountry(row?.CustomerCountry);
  };
  const handleClose = () => setOpen(false);

  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "firstname",
      headerName: "Member Name",
      width: 200,
      renderCell: (params) => {
        const userFullName =
          // params?.firstname + " " + params?.lastname;
          params?.row?.user?.firstname.charAt(0).toUpperCase() +
          params?.row?.user?.firstname.slice(1) +
          " " +
          params?.row?.user?.lastname.charAt(0).toUpperCase() +
          params?.row?.user?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "applied_at",
      headerName: "Used by Signup/Invest",
      width: 300,
    },

    {
      field: "createdAt",
      headerName: "Date Associated",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.user?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "totalInvestment",
      headerName: "Total Investment",
      width: 150,
    },
    {
      field: "raisedAmount",
      headerName: "Total Raised",
      width: 100,
    },
    {
      field: "commision",
      headerName: "Commission",
      width: 150,
    },
    {
      field: "commisionAmount",
      headerName: "Amount",
      width: 150,
    },
  ];

  useEffect(() => {
    // handleOnClick();
    // fetchStaffMembers();
    // fetchReporData();
    getAllReferrals();
  }, [pageState.page, pageState.pageSize]);
  const handleChangeManager = (e) => {
    setEmployeeID(e.value);
    setEmployee(e);
    fetchUserReferalData(e.value);
  };

  const fetchStaffMembers = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-list-of-employees",
      headers: {
        "x-access-token": token,
      },
      data: {
        limit: 500,
        page: 1,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        const options = data.map((d) => ({
          value: d.users.id,
          label: d.users?.firstname + "-" + d.designation?.designation,
        }));

        setEmployees(options);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getAllReferrals = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-our-referrals",
      headers: {
        "x-access-token": token,
      },
      data: {
        pagination: false,
        page: pageState.page,
        limit: pageState.pageSize,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;
        const options = data.map((d) => ({
          value: d.id,
          label:
            d?.firstname.charAt(0).toUpperCase() +
            d?.firstname.slice(1) +
            " " +
            d?.lastname.charAt(0).toUpperCase() +
            d?.lastname.slice(1),
        }));
        // setPageState((old) => ({
        //   ...old,
        //   data: response.data.data.rows,
        //   total: response.data.data.count,
        // }));
        setEmployees(options);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const fetchReporData = (endDate) => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "reports/user_investments",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: employeeID,
        comission_from_date: startDate,
        comission_to_date: endDate,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        setReportUrl(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  const fetchUserReferalData = (employeeID) => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/referal/details-by-userId",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: employeeID,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        // setReportUrl(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };

  const handleEndDate = (e) => {
    setEndDate(e.target.value);
    // fetchReporData(e.target.value);
  };

  // const handleExportExcel = () => {
  //   const url = reportUrl.slice(-1);
  //   const link = document.createElement("a");
  //   link.href = url[0].url;
  //   link.download = "abc.csv";
  //   link.click();
  //   // setPdfDownload(url[0]?.url);
  // };

  const handleExportExcel = async () => {
    const token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "reports/user_investments",

      data: {
        user_id: employeeID,
        comission_from_date: startDate,
        comission_to_date: endDate,
      },
    };

    axios(config)
      .then(function async(response) {
        if (response) {
          setLoading(false);
          var abc = base64ToBlob(response.data, "application/vnd.ms-excel");
          const url = window.URL.createObjectURL(abc);
          const link = document.createElement("a");
          link.href = url;
          const filename = getDateFormat(new Date());
          link.setAttribute("download", `${filename}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  const getDateFormat = (date) => {
    const today = date;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return yyyy + "" + mm + "" + dd;
  };

  const base64ToBlob = (base64Data, contentType) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/users/${params.row.applied_by} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                {/* <RemoveRedEyeOutlinedIcon /> */}
                View Profile
              </div>
            </Link>

            <Link
              to={`/report/${params.row.applied_by} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                {/* <RemoveRedEyeOutlinedIcon /> */}
                Investments
              </div>
            </Link>
            {/* <div className="viewButton" onClick={() => handleOpen(params?.row)}>
              <RemoveRedEyeOutlinedIcon />
            </div> */}
          </div>
        );
      },
    },
  ];

  return (
    <div className="list">
      {/* <Sidebar /> */}
      <div className="listContainer">
        {/* <Navbar /> */}

        <div className="datatable">
          <h5 className="h5Title" style={{ textAlign: "center" }}>
            Staff - Client Report{" "}
          </h5>
          <div className="datatableTitle">
            <div className="tablesearch tableTopFilter">
              <div className="topFilter-div">
                <Select
                  options={employees}
                  onChange={handleChangeManager}
                  value={getEmployee}
                />
                <div className="dFlex custInput-div">
                  <label className="cust-label">Date From</label>
                  <input
                    type="date"
                    name="startDate"
                    // min={disablePastDate()}
                    {...register("startDate", {
                      required: "Start Date is required",
                    })}
                    placeholder="Enter Start Date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  {errors.startDate && (
                    <div className="invalid-feedback">
                      {errors.startDate.message}
                    </div>
                  )}
                </div>
                <div className="dFlex custInput-div">
                  <label className="cust-label">Date To</label>
                  <input
                    type="date"
                    name="endDate"
                    // min={disablePastDate()}
                    {...register("endDate")}
                    placeholder="Enter End Date"
                    value={endDate}
                    onChange={handleEndDate}
                  />
                  {errors.endDate && (
                    <div className="invalid-feedback">
                      {errors.endDate.message}
                    </div>
                  )}
                </div>
              </div>
              {/* <Pdf targetRef={ref} filename="code-example.pdf">
        {({ toPdf }) => <button onClick={toPdf}>Generate Pdf</button>}
      </Pdf> */}
              <button
                className="custBtn opac"
                id="downloadbtn"
                onClick={handleExportExcel}
              >
                Export as Excel
              </button>
              {/* <div ref={ref} >
                <div style={{display : "none"}}>
        <h1>Hello CodeSandbox</h1>
        <h2>Start editing to see some magic happen!</h2>
        </div>
      </div> */}
            </div>
          </div>
          <DataGrid
            className="datagrid"
            autoHeight
            rows={pageState.data}
            rowCount={pageState.total}
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pagination
            page={pageState.page - 1}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage + 1 }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
            columns={userColumns.concat(actionColumn)}
          />
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-popup">
          <div className="modal-top">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              View Report
            </Typography>
            <Button className="closeBtn" onClick={() => setOpen(false)}>
              <img src={Close} alt="close-icon" />
            </Button>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 1 }}>
            <div className="new">
              <div className="newContainer">
                <div
                  className="bottom"
                  style={{ boxShadow: "none", padding: "0" }}
                >
                  <div className="right">
                    <form className="accredited-investorForm">
                      <div className="formInput" id="commissionInput">
                        <label>Email : {CuctomerEmail}</label>
                        <label>Campaign Name : {CampaignName}</label>
                        <label>Amount Invested : {AmountInvested}</label>
                        <label>Commission : {COMMISSION}</label>

                        <label>Country : {CustomerCountry}</label>
                      </div>

                      <div className="item accreditedItem">
                        <div className="details profile-info">
                          <div className="submitButton">
                            <button
                              className="cancelButton"
                              type="button"
                              onClick={() => setOpen(false)}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Report;
